import { getRequestId } from 'saddlebag-browser';
import {
  getUtid,
  isLoggedIn,
  TRAVELLER_AUTHENTICATION_STATE,
} from 'saddlebag-user-management';
import { ViewSender } from 'saddlebag-view-tracking';

import { redactUrl } from '../redactUrl';

const getUserAuthState = async () =>
  (await isLoggedIn())
    ? TRAVELLER_AUTHENTICATION_STATE.AUTHENTICATED
    : TRAVELLER_AUTHENTICATION_STATE.UNAUTHENTICATED;

export const sendViewViewEvent = async ({
  culture,
  device,
  featureTests,
  micrositeName,
  pageContext,
  requestId,
  userInfo,
  viewGuid,
  virtualReferrer,
  webNodeOverride,
}) => {
  const explicitDevice = {
    browserName: device.browserName,
    browserVersion: device.browserVersion,
    desktop: device.isBrowser,
    mobile: device.isMobilePhone,
    tablet: device.isTablet,
    osVersion: device.osVersion,
  };
  const explicitCulture = {
    market: culture.market,
    currency: culture.currency,
    locale: culture.locale,
  };

  const userAuthState = await getUserAuthState();
  const { allowedQueryParams } = pageContext;
  return new ViewSender().sendView(
    {
      opts: {
        culture: explicitCulture,
        device: explicitDevice,
        featureTests,
        isInternalUser: userInfo.isInternalUser,
        redactUrl: (currentUrl) =>
          redactUrl(currentUrl, { allowedQueryParams }),
        virtualReferrer,
        ...pageContext,
        requestId: requestId || getRequestId(),
      },
      trackingOpts: {
        WebNode: webNodeOverride || micrositeName,
        guid: viewGuid,
      },
    },
    () => getUtid(),
    userInfo.authState || userAuthState,
  );
};
